import { useTranslation } from "react-i18next";
import { ArrowLeft, Layers } from "lucide-react";
import { Button } from "components/common/Button";
import { TruncatedTextTooltip } from "components/common/TruncatedTextTooltip";
import type { ZoneHeaderProps } from "./types";

export const ZoneHeader = ({
  zoneName,
  roomCount,
  onBack,
}: ZoneHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2 mb-3 px-2 py-1.5 rounded-lg border border-blue-200 bg-blue-50">
      <Button
        variant="primary"
        size="sm"
        onClick={onBack}
        startAdornment={<ArrowLeft className="w-4 h-4" />}
        aria-label={t("smartSurveyor.zones.backToZones")}
      />
      <Layers className="w-4 h-4 shrink-0 text-blue-600" />
      <TruncatedTextTooltip
        text={zoneName}
        className="flex-1 min-w-0 text-base font-bold text-blue-800"
      />
      <span className="shrink-0 text-sm font-medium text-blue-700">
        {t("smartSurveyor.zones.roomsCount", { count: roomCount })}
      </span>
    </div>
  );
};
